(() => {
  if (customElements.get('capkov-lang-switch')) return;
  const codes = ['en', 'de', 'fr', 'pl', 'hu', 'da', 'bg', 'ro', 'hr', 'it', 'es', 'fi', 'sv', 'sl', 'nl'];
  class CapkovLangSwitch extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const url = new URL(window.location.href);
      const options = this.querySelector('[data-lang-options]');
      if (url.searchParams.get('lang_preview') === '1') {
        // Strip the current localized root once; retain the resource, query and hash.
        let path = url.pathname;
        const root = this.dataset.root.replace(/\/$/, '');
        if (root && (path === root || path.startsWith(root + '/'))) {
          path = path.slice(root.length) || '/';
        } else {
          const prefix = path.split('/')[1];
          if (codes.includes(prefix)) path = path.slice(prefix.length + 1) || '/';
        }
        const fragment = this.querySelector('[data-lang-preview]').content.cloneNode(true);
        fragment.querySelectorAll('[data-code]').forEach(link => {
          const code = link.dataset.code;
          const target = new URL(url);
          // English is the primary language, so its canonical root has no /en prefix.
          target.pathname = (code === 'en' ? '' : '/' + code) + path;
          link.href = target.href;
          if (code === this.dataset.current) link.setAttribute('aria-current', 'true');
        });
        options.replaceChildren(fragment);
        this.hidden = false;
      }
      // Impact supplies focus trapping, Escape, aria-expanded and focus restoration.
      // Add arrow/Home/End navigation to the native links and submit buttons.
      options.addEventListener('keydown', event => {
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        const items = Array.from(options.querySelectorAll('a[href], button'));
        const index = items.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        let next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items[next].focus();
      });
    }
  }
  customElements.define('capkov-lang-switch', CapkovLangSwitch);
})();
